<template>
  <v-dialog scrollable max-width="900px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <!-- <v-btn small v-on="on" @click="cargar">FICHA</v-btn> -->
        <a v-on="on" @click="cargar"> {{ persona.nombreCompleto }}</a>
      </div>
    </template>

    <v-card v-if="persona">
      <v-card-title>
        <h4>FICHA DIGITAL</h4>
      </v-card-title>
      <v-card-text>

        <input ref="fileSelector" accept="image/*" type="file" class="d-none">
        <div class="d-flex flex-wrap align-center">

          <FotoUpload :cedula="persona.cedula" :fileName="persona.cedula" @uploaded="cargar" class="pa-2" />

          <div class="mt-2" style="max-width: 500px">
            <div>
              <h5 class="mb-2 mt-3">Datos personales</h5>
            </div>
            <div>Nombres: {{ persona.nombreCompleto }} </div>
            <div>Número de Cédula: {{ persona.cedula }} </div>
            <div v-if="persona.fechaNacimiento">Fecha de Nacimiento {{ persona.fechaNacimiento | dateFormat }} ({{
              calculateAge(persona) }} años de edad)</div>


            <div>
              <h5 class="mb-2 mt-3">Datos del socio</h5>
            </div>
            <div>Número IP: {{ persona.ipName }} </div>
            <div>Codigo SGS: {{ persona.codMemSq }} </div>
            <div v-if="persona.fechaIngreso">Fecha de Ingreso: {{ persona.fechaIngreso | dateFormat }} ({{
              calculateAntSoc(persona) }} años de antiguedad)</div>
            <div>Tipo de Socio: {{ persona.memType }}</div>
            <div v-if="persona.fechaDefuncion">Fecha de Defunción: {{ persona.fechaDefuncion | dateFormat }}</div>
            <div>Contrato: {{ persona.contratoGestion }}</div>
            <div>ContratoHeredero: {{ persona.contratoGestionHeredero }}</div>



            <div>
              <h5 class="mb-2 mt-3">Datos de la cuenta del pago</h5>
            </div>


            <div v-if="cuenta">


              <div>Banco: {{ cuenta.nombreBanco || "" }} </div>
              <div>Número de Cuenta: {{ cuenta.numeroCuenta || "" }} </div>
              <div>Nombre Titultar: {{ cuenta.nombreTitularCuenta || "" }} </div>
              <div>Numero Documento: {{ cuenta.tipoDocumentoCuenta || "" }} {{
                cuenta.numeroDocumentoCuenta || "" }} </div>
            </div>

            <div>
              <h5 class="mb-2 mt-3">Contacto</h5>
            </div>
            <div>Teléfono: {{ persona.celular }}</div>
            <div>Localidad: {{ persona.localidad }}</div>
            <div>Dirección: {{ persona.direccion }}</div>
          </div>

          <!-- {{ persona }} -->




        </div>

        <!-- <v-form ref="form">
              <v-text-field type=text label="Número de cedula" v-model="nuevaCedula" autofocus/>
            </v-form> -->

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="showDialog = false">Volver</v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" @click="imprimirObras">IMPRIMIR OBRAS</v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" @click="imprimirAyuda">EXTRACTO DE AYUDAS</v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" @click="imprimir">IMPRIMIR FICHA</v-btn>
        <!-- <v-btn color="info" @click="confirmar">Actualizar</v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import moment from 'moment';
import FotoUpload from '@/components/ficha/FotoUpload.vue'
import axios from "axios";
import { saveAs } from "file-saver";

export default {

  props: ['persona'],


  components: { FotoUpload },
  data() {
    return {
      showDialog: false,
      imageBytes: null,
      loading: false,
      cuenta: null
    }
  },
  mounted() { },
  methods: {
    cargar() {

      if (!this.cuenta) {
        axios.get('/persona/' + this.persona.id + '/cuentaBancaria').then(res => {
          this.cuenta = res.data;
        }).catch(err => console.log(err));

      }

    },

    calculateAge(persona) { // birthday is a date
      const fechaDesde = new Date(persona.fechaNacimiento);
      const fechaHasta = persona.fechaDefuncion ? new Date(persona.fechaDefuncion) : new Date();
      const ageDifMs = fechaHasta - fechaDesde;
      const ageDate = new Date(ageDifMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },

    calculateAntSoc(persona) { // birthday is a date
      const fechaDesde = new Date(persona.fechaIngreso)
      const fechaHasta = persona.fechaDefuncion ? new Date(persona.fechaDefuncion) : new Date()
      const ageDifMs = fechaHasta - fechaDesde;
      const ageDate = new Date(ageDifMs); // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },
    selectFile() {
      console.log('select file', this.$refs)
      console.log('select file', this.$refs.fileSelector.click())
    },
    imprimir() {
      this.loading = true;
      axios.post("/reports", {
        dbName: "SIAPA",
        reportName: "ficha_digital.jrxml",
        base64: true,
        params: [
          { nombre: "id", valor: this.persona.id, tipo: "integer" }
        ],
      })
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.errorMessage = err.response.data;
        });
    },
    imprimirAyuda() {
      this.loading = true;
      axios
        .post("/reports", {
          dbName: "SIAPA",
          reportName: "extracto_ayudas_socios.jrxml",
          base64: true,
          params: [
            { nombre: "COD_MEM_SQ", valor: this.persona.codMemSq, tipo: "integer" },
            { nombre: "USUARIO", valor: this.$store.getters.user.username },
            { nombre: "ANIO_DESDE", valor: new Date().getFullYear(), tipo: "integer" },
            { nombre: "ANIO_HASTA", valor: new Date().getFullYear(), tipo: "integer" }
          ],
        })
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.errorMessage = err.response.data;
        });
    },
    imprimirObras() {
      this.loading = true;
      axios
        .post("/reports", {
          dbName: "SGS",
          reportName: "ficha_digital_obras.jrxml",
          base64: true,
          params: [
            { nombre: "ip_name", valor: this.persona.ipName, tipo: "long" }
          ],
        })
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.errorMessage = err.response.data;
        });
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  },
  filters: {
    dateFormat(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
  },
}
</script>

<style></style>